import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API } from '../config';

export default function Lander() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Verifying...');

  useEffect(() => {
    const processToken = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('No token provided, redirecting...');
        setTimeout(() => navigate('/', { replace: true }), 1000);
        return;
      }

      try {
        // Decode the token to get user info
        const decoded = jwtDecode(token);
        
        // Check if token is expired
        if (decoded.exp && decoded.exp * 1000 < Date.now()) {
          setStatus('Token expired, redirecting to login...');
          setTimeout(() => navigate('/login', { replace: true }), 1500);
          return;
        }

        // Store the token
        localStorage.setItem('token', token);
        
        // Verify token with backend and get user data
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          if (response.data) {
            // Store user data
            localStorage.setItem('user', JSON.stringify(response.data));
            setStatus('Verified! Redirecting to dashboard...');
            
            // Redirect based on role
            setTimeout(() => {
              if (decoded.role === 'super_admin' || decoded.role === 'limited_admin') {
                navigate('/dashboard', { replace: true });
              } else if (decoded.role === 'leadership') {
                navigate('/dashboard', { replace: true });
              } else if (decoded.role === 'member') {
                navigate('/group-selection', { replace: true });
              } else {
                navigate('/login', { replace: true });
              }
            }, 500);
          }
        } catch (apiError) {
          console.error('API verification failed:', apiError);
          setStatus('Verification failed, redirecting to login...');
          localStorage.removeItem('token');
          setTimeout(() => navigate('/login', { replace: true }), 1500);
        }
      } catch (error) {
        console.error('Invalid token:', error);
        setStatus('Invalid token, redirecting to login...');
        setTimeout(() => navigate('/login', { replace: true }), 1500);
      }
    };

    processToken();
  }, [navigate, searchParams]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #FEFAE0 0%, #FFF8E1 100%)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #E5E7EB',
          borderTopColor: '#3B82F6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }} />
        <h2 style={{ color: '#1F2937', marginBottom: '8px' }}>ChamaLink</h2>
        <p style={{ color: '#6B7280' }}>{status}</p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
